import styled from "@emotion/styled";

export const Button = styled.button`
  position: relative;

  padding: 0;

  color: inherit;
  font: inherit;

  border: none;

  background-color: transparent;

  cursor: pointer;
`;

export const Content = styled.span`
  position: relative;
  z-index: 2;
`;
